import React, { useEffect, useRef } from "react";
import { ButtonPopup, Input } from "../ui";

interface PopupCodigoProfesionProps {
  show: boolean;
  profesion: string | null;
  codigo: string;
  setCodigo: (value: string) => void;
  onCancel: () => void;
  onAccept: () => void;
  errorCodigo?: string;
  loading?: boolean;
}

const PopupCodigoProfesion: React.FC<PopupCodigoProfesionProps> = ({
  show,
  profesion,
  codigo,
  setCodigo,
  onCancel,
  onAccept,
  errorCodigo,
  loading = false,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!show) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };


    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [show, onCancel]);

  useEffect(() => {
    if (errorCodigo) {
      setCodigo(""); // 🔥 limpia input cuando hay error
    }
  }, [errorCodigo, setCodigo]);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
      onCancel();
    }
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center
                 bg-black/40 backdrop-blur-sm
                 animate-fadeIn"
      onClick={handleBackdropClick}
    >
      <div
        ref={modalRef}
        className="
          w-80 p-6 rounded-2xl
          bg-white/70 backdrop-blur-xl
          border border-white/40
          shadow-[0_20px_60px_rgba(0,0,0,0.35)]
          transform transition-all duration-300
          animate-popupScale
        "
      >
        {/* TITULO */}
        <h2 className="text-lg font-bold text-zinc-800 mb-2">
          Código requerido
        </h2>

        <p className="text-sm text-zinc-700 mb-4">
          Introduce el código para{" "}
          <strong>{profesion ?? ""}</strong>
        </p>

        {/* INPUT */}
        <Input
          type="password"
          value={codigo}
          onChange={(e) => setCodigo(e.target.value)}
          placeholder={
            errorCodigo
              ? errorCodigo
              : "Introduce el código..."
          }
          className={`
            w-full px-3 py-2 rounded-md mb-4
            bg-white/60 backdrop-blur
            border transition-all outline-none
            ${errorCodigo
              ? "!border-red-400 !placeholder-red-500"
              : "!border-white/40 !focus:border-blue-400"
            }
            focus:ring-2 focus:ring-blue-300
          `}
          autoFocus
        />

        {/* BOTONES */}
        <div className="flex justify-end gap-2">
          <ButtonPopup
            onClick={onCancel}
            disabled={loading}

          >
            Cancelar
          </ButtonPopup>

          <ButtonPopup
            onClick={onAccept}
            disabled={!codigo.trim() || loading}
            className={`
              px-3 py-1 rounded-md text-white transition
              ${codigo.trim() && !loading
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-blue-300 cursor-not-allowed"
              }
            `}
          >
            {loading ? "Validando..." : "Aceptar"}
          </ButtonPopup>
        </div>
      </div>
    </div>
  );
};

export default PopupCodigoProfesion;